<template>
    <div class="inline-flex rounded-md shadow-sm" role="group">
      <button
        v-for="(button, index) in buttons"
        :key="button.name"
        type="button"
        :class="[
          'p-1 text-sm font-medium transition-all duration-200 ease-in-out',
          index === 0 ? 'rounded-l-lg' : '',
          index === buttons.length - 1 ? 'rounded-r-lg' : '',
          activeButton === button.name
            ? 'bg-blue-600 text-white shadow-inner ring-2 ring-blue-300 ring-inset'
            : 'bg-white text-gray-700 hover:bg-gray-50 hover:text-gray-900',
          'border border-gray-300',
          index !== 0 ? 'border-l-0' : '',
          'focus:z-10 focus:outline-none focus:ring-2 focus:ring-blue-500'
        ]"
        @click="setActiveButton(button.name)"
      >
        <component :is="button.icon" class="w-5 h-5" :class="{ 'filter drop-shadow-md': activeButton === button.name }" />
      </button>
    </div>
  </template>
  
  <script>
  import { ref } from 'vue';
  import { ViewColumnsIcon, TableCellsIcon, Squares2X2Icon } from '@heroicons/vue/24/outline';
  
  export default { 
    components: {
      ViewColumnsIcon,
      TableCellsIcon,
      Squares2X2Icon,
    },
    setup(props, { emit }) {
      const activeButton = ref('list');
      const buttons = [
        { name: 'list', icon: ViewColumnsIcon },
        { name: 'pivot', icon: TableCellsIcon },
        { name: 'custom', icon: Squares2X2Icon },
      ];
  
      const setActiveButton = (buttonName) => {
        activeButton.value = buttonName;
        emit('layout_selected', buttonName);
      };
  
      return {
        activeButton,
        buttons,
        setActiveButton,
      };
    },
  };
  </script>